import { NgModule } from '@angular/core';
import { PlatformAdminGuard } from './pages-admin/platform-admin.guard';
import { RouterModule, Routes } from '@angular/router';

import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

import { AngularFireAuthGuard } from '@angular/fire/compat/auth-guard';
import { WorkersLayoutComponent } from './layouts/workers-layout/workers-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },

  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/layouts/home-layout/home-layout.module').then(
            (m) => m.HomeLayoutModule
          ),
      },
    ],
  },

  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivateChild: [PlatformAdminGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/layouts/admin-layout/admin-layout.module').then(
            (m) => m.AdminLayoutModule
          ),
      },
    ],
  },

  {
    path: 'workers',
    component: WorkersLayoutComponent,
    canActivateChild: [PlatformAdminGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/layouts/workers-layout/workers-layout.module').then(
            (m) => m.WorkersLayoutModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
